import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ManningAgencyAdminService } from '../../../core/manning-agency-admin.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-manning-agency-pending-profile',
  templateUrl: './manning-agency-pending-profile.component.html',
  styleUrls: ['./manning-agency-pending-profile.component.css']
})
export class ManningAgencyPendingProfileComponent implements OnInit {
  token;
  maId;
  profile = {
    name: '',
    email: '',
    contactPerson: '[{}]',
    operatingDays: '',
    companyLogo: '',
    about: '',
    address: '',
    operatingHours: '',
    telNumber: '',
    mobileNumber: '',
    poeaLicenseNumber: '',
  };
  rejectedReason = '';

  constructor(
    public location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService,
    private manningAgencyService: ManningAgencyAdminService
  ) { }

  ngOnInit() {
    this.token = this.cookieService.get('token');
    this.maId = this.route.snapshot.paramMap.get('id');
    this.manningAgencyService.getProfile(this.token, this.maId)
      .subscribe(res => {
        if (res && res.success) {
          if (res.data.isAccepted) {
            return this.router.navigate([`/admin/manning-agency/${this.maId}`]);
          } else if (res.data.isRejected) {
            return this.router.navigate([`/admin/manning-agency`]);
          }
          this.profile = res.data;
        }
      });
  }

  approve() {
    this.manningAgencyService.updateStatus(this.token, this.maId, 'approved')
      .subscribe(res => {
        if (res && res.success) {
          this.location.back();
        }
      });
  }

  reject() {
    const data = {
      rejectedReason: this.rejectedReason,
    };

    this.manningAgencyService.updateStatus(this.token, this.maId, 'rejected', data)
      .subscribe(res => {
        if (res && res.success) {
          this.location.back();
        }
      });
  }

}
